import React from "react";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import {
  Card,
  CardContent,
  Grid2,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import { useFormik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import API from "../../../../api/axios";
import { setToast } from "../../../../store/slices/toastSlice";
import { useDispatch } from "react-redux";

const breadcrumbs: BreadcrumbsModel[] = [
  { name: "Position Tracker", route: "/admin/position-tracker" },
  { name: "Raise Query" },
];

const RaiseQuery = () => {
  const navigate = useNavigate();
  const state = useLocation();
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      queryTitle: "",
      description: "",
    },
    validationSchema: Yup.object({
      queryTitle: Yup.string()
        .min(3, "Minimum 3 characters required")
        .required("Query Title is required.")
        .matches(/^(?!.*<[^>]+>).*/, "HTML tags are not allowed"),
      description: Yup.string()
        .required("Description is required.")
        .min(3, "Minimum 3 characters required")
        .max(500, "Maximum 500 characters only allowed")
        .matches(/^(?!.*<[^>]+>).*/, "HTML tags are not allowed"),
    }),
    onSubmit: async (values) => {
      try {
        const response = await API.post("/query/raise", {
          title: values.queryTitle,
          description: values.description,
          position_id: state?.state?.data?.id,
          candidate_pos_eligibility_id:
            state?.state?.data?.eligible_positions[0]?.id,
        });
        dispatch(
          setToast({
            message: "Query raised successfully",
            severity: "success",
            open: true,
          })
        );
        navigate("/admin/position-tracker");
      } catch (error) {
        // Raise query request failed; success navigation remains unchanged
      }
    },
  });

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="Raise Query">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() =>
            navigate("/admin/position-tracker", { state: state?.state })
          }
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        <form onSubmit={formik.handleSubmit}>
          <CardContent sx={{ padding: { xs: 0, md: "16px" } }}>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Position Title</Typography>
                <Typography variant="subtitle2">
                  {state?.state?.data?.name || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Level</Typography>
                <Typography variant="subtitle2">
                  {state?.state?.data?.level || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Status</Typography>
                <Typography variant="subtitle2">Not Eligible</Typography>
              </Grid2>
              <Grid2 size={12} marginBottom={2}>
                <TextField
                  label="Query Title *"
                  variant="outlined"
                  defaultValue="Application Rejection Dispute"
                  fullWidth
                  id="queryTitle"
                  name="queryTitle"
                  value={formik.values.queryTitle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.queryTitle &&
                    Boolean(formik.errors.queryTitle)
                  }
                  helperText={
                    formik.touched.queryTitle && formik.errors.queryTitle
                  }
                />
              </Grid2>
              <Grid2 size={12} marginBottom={1}>
                <TextField
                  label="Description *"
                  variant="outlined"
                  defaultValue="Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi "
                  fullWidth
                  multiline
                  rows={4}
                  id="description"
                  name="description"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.description &&
                    Boolean(formik.errors.description)
                  }
                  helperText={
                    formik.touched.description && formik.errors.description
                  }
                />
              </Grid2>
              {/* Buttons */}
              <Grid2 size={12} display="flex" justifyContent="flex-end">
                <Button
                  type="submit"
                  variant="secondary"
                  variantType="contained"
                  label="Raise Query"
                  disabled={!formik.isValid || !formik.dirty}
                />
              </Grid2>
            </Grid2>
          </CardContent>
        </form>
      </Card>
    </PageWrapper>
  );
};

export default RaiseQuery;
